import { useEffect } from "react";
import { Cookie } from "../hooks/useStorage";
import AuthTextInput from "../components/common/commonTextInputs/authTextInput";
import CommonDropDown from "../components/common/commonDropDown/commonDropDown";
import BasicDatePicker from "../components/common/commonDatePicker/CommonDatePicker";
import dayjs from "dayjs";
import CommonTextArea from "../components/common/commonTextInputs/CommonTextArea";
import Cookies from "js-cookie";
import { eventCol } from "../interface/types";

export const logoutUser = () => {
  // Cookie.clear();
  Cookies.set("ur", "0");
  Cookies.remove("access_token");
  Cookies.remove("email");
  Cookies.remove("userId");
  Cookies.remove("role");
  Cookies.remove("role_id");
  Cookies.remove("enquiryId");
  Cookies.remove("eventId");
  Cookies.remove("companyId");
  Cookies.remove("isNotificationEnabaledOrAskedAlready");
  localStorage.removeItem("xero_tokens");
  window.location.href = "/";
};

export const useEnterKey = (callback: () => void) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Enter") {
        console.log("Enter key pressed!");
        callback();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [callback]);
};

export const useEnterRefKey = (
  callback: () => void,
  ref: React.RefObject<HTMLElement>
) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Enter") {
        event.preventDefault(); // Optional: prevent default form submission
        callback();
      }
    };

    const node = ref?.current;
    if (node) {
      node.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      if (node) {
        node.removeEventListener("keydown", handleKeyDown);
      }
    };
  }, [callback, ref]);
};

//Function to render fields based on form type
interface FormFieldInfo {
  type: string;
  label: string;
  placeholder?: string;
}
export const renderFormField = (
  info: any,
  options: any,
  value: string,
  setValue: (value: string) => void,
  customSelectStyles: { width?: number; height?: number; margin?: number },
  error?: string, 
  validationErrors?:any,
  formValues?:any,
  setFormValues?: React.Dispatch<React.SetStateAction<any>>,
  setValidationErrors?: React.Dispatch<React.SetStateAction<Record<string, string>>>

) => {
  const { width, height, margin } = customSelectStyles;
  switch (info?.type) {
    case "textBox":
      return (
        <div className="w-full">
        <AuthTextInput
          key={info?.label}
          label={info?.label}
          placeholder={info?.placeholder}
          value={value || ''}
          onChange={setValue} // Now this receives just the value
          customStyle={{
            backgroundColor: "transparent",
            border: "1px solid #151B2D4D",
            flexDirection: "row",
          }}
          module={"invoice"}
          required={info?.isRequired}
        />
        {error && <p className="text-red-500 text-xs !mt-2 !ml-[8.5rem]">{error}</p>}
        </div>
      );

    case "select":
      return (
        <div className="!mt-[28px] flex justify-between w-full items-center gap-4">
          <h2 className="min-w-[6rem]">{info?.label}</h2>
          <CommonDropDown
            placeholder={info?.placeholder || "Select Currency"}
            options={options}
            value={value}
            onChange={(newValue) => setValue(newValue)}
            width={width}
            height={height}
            margin={margin}
            required={info?.isRequired}
          />
        </div>
      );
    case "textArea":
      return (
        <div className="w-full">
        <CommonTextArea
          label={info?.label}
          placeholder={info?.placeholder}
          name={name}
          customStyles={{flexDirection:'row',marginTop:'2rem',alignItems:'center',justifyContent:'spaceBetween'}}
          textAreaStyles={{width:'75%'}}
          value={value}
          onChange={(e:any)=>e.target.value}
        />
        {error && <p className="text-red-500 text-xs mt-1 mr-5">{error}</p>}
        </div>
      );
    case "date":
      if (info.name === "invoiceDate" || info.name === "dueDate") {
        return (
          <div className="w-full min-w-0">
            <BasicDatePicker
              label={info?.label}
              value={value}
              onChange={(newDate: any) => setValue(newDate)}
              disable={info.name === "invoiceDate"}
              minDate={
                info.name === "dueDate"
                  ? dayjs().add(1, "day").toDate()
                  : undefined
              }
              customStyles={{
                flexDirection: "row",
                alignItems: "center",
                gap: "1rem",
                width: "100%",
                marginTop: "2rem",
              }}
              module={info.name === "dueDate" ? "invoice" : undefined}
              required={info.name === "dueDate" ? info?.isRequired : undefined}
            />
            {info.name === "dueDate" && error && (
              <p className="text-red-500 text-xs !mt-2 !ml-[8.5rem]">{error}</p>
            )}
          </div>
        );
      }
      break;

    case "addressGroup":
      return (
        <>
          {info.fields.map((field: any) => {
            const isSpecialField = field.isSpecialField;
            const fieldError = isSpecialField
              ? validationErrors?.[field.name]
              : validationErrors?.[`address.${field.name}`];
            const fieldValue = isSpecialField
              ? formValues?.[field.name] || ""
              : formValues?.address?.[field.name] || "";

            return (
              <div key={field.name} className="w-full min-w-0">
                <AuthTextInput
                  label={field.label}
                  placeholder={field.placeholder}
                  disable={field.name === "amount"}
                  value={fieldValue}
                  module="invoice"
                  required={field.isRequired}
                  onChange={(e: any) => {
                    if (isSpecialField) return;
                    const val = typeof e === "string" ? e : e?.target?.value;

                    if (setFormValues) {
                      setFormValues((prev: any) => ({
                        ...prev,
                        address: {
                          ...prev.address,
                          [field.name]: val,
                        },
                      }));
                    }

                    if (setValidationErrors) {
                      setValidationErrors((prev) => {
                        const newErrors = { ...prev };
                        delete newErrors[`address.${field.name}`];
                        return newErrors;
                      });
                    }
                  }}
                  customStyle={{
                    backgroundColor: "transparent",
                    border: "1px solid #151B2D4D",
                    flexDirection: "row",
                  }}
                />
                {fieldError && (
                  <p className="text-red-500 text-xs !mt-2 !ml-[8.5rem]">
                    {fieldError}
                  </p>
                )}
              </div>
            );
          })}
        </>
      );

    default:
      return null;
  }
};

export const formattedDate = (date: Date | null) => {
  if (date === null) return null;
  else {
    return dayjs(date).format("YYYY-MM-DD");
  }
};

// utils/dateFormatter.ts
export const formatDateToDDMMYYYY = (date: Date | null): string | null => {
  if (!date || !(date instanceof Date) || isNaN(date.getTime())) {
    return null;
  }
  
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  
  return `${day}-${month}-${year}`;
};

export const getFutureDate = () => {
  const today = new Date();
  today.setDate(today.getDate() + 2);

  return today.toLocaleDateString("en-GB"); 
  // en-GB -> DD/MM/YYYY format
};

export const parseDDMMYYYYToDate = (dateString: string): Date | null => {
  if (!dateString) return null;
  
  // Try to parse as ISO format first
  if (dateString.includes('T')) {
    const date = new Date(dateString);
    return isNaN(date.getTime()) ? null : date;
  }
  
  // Fall back to DD-MM-YYYY format
  const [day, month, year] = dateString.split('-').map(Number);
  if (!day || !month || !year) return null;
  
  return new Date(year, month - 1, day);
};


// Add the status options array after other constants
export const statusOptions = [
  "NEW",
  "CONTACTED",
  "MEETING",
  "PROPOSAL SENT",
  "SITE VISIT",
  "NEGOTIATING",
  "CONTRACT SENT",
  "CONFIRMED",
  "LOST"
]; 

export const statusMapping: { [key: string]: string } = {
  "NEW": "new",
  "CONTACTED": "contacted",
  "MEETING": "meeting",
  "PROPOSAL SENT": "proposal_sent",
  "SITE VISIT": "site_visit",
  "NEGOTIATING": "negotiating",
  "CONTRACT SENT": "contract_sent",
  "CONFIRMED": "confirmed",
  "LOST": "lost"
};

 // File validation functions
  export const validateMainImage = (files: File[] = []) => {
    const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
    const maxSizeInBytes = 5 * 1024 * 1024;

    if (files.length > 1) {
      return { valid: false, message: "Only one main image is allowed" };
    }

    const invalidType = files.find((file: any) => !allowedTypes.includes(file.type || file.mimetype));
    if (invalidType) {
      return { valid: false, message: "Only JPG, PNG, JPEG images are allowed for main image" };
    }

    const tooLarge = files.find((file) => file.size > maxSizeInBytes);
    if (tooLarge) {
      return { valid: false, message: "Main image must be less than 5MB" };
    }

    return { valid: true };
  };

  export const validateSubImages = (files: File[] = []) => {
    const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
    const maxSizeInBytes = 5 * 1024 * 1024;

    if (files.length > 3) {
      return { valid: false, message: "Maximum 3 sub images allowed" };
    }

    const invalidType = files.find((file: any) => !allowedTypes.includes(file.type || file.mimetype));
    if (invalidType) {
      return { valid: false, message: "Only JPG, PNG, JPEG images are allowed for sub images" };
    }

    const tooLarge = files.find((file) => file.size > maxSizeInBytes);
    if (tooLarge) {
      return { valid: false, message: "Each sub image must be less than 5MB" };
    }

    return { valid: true };
  };

  export const validateVideo = (files: File[] = []) => {
    const allowedTypes = ["video/mp4", "application/mp4"];
    const maxSizeInBytes = 50 * 1024 * 1024;

    if (files.length > 1) {
      return { valid: false, message: "Only one video is allowed" };
    }

    const invalidType = files.find((file: any) => !allowedTypes.includes(file.type || file.mimetype));
    if (invalidType) {
      return { valid: false, message: "Only MP4 videos are allowed" };
    }

    const tooLarge = files.find((file) => file.size > maxSizeInBytes);
    if (tooLarge) {
      return { valid: false, message: "Video must be less than 50MB" };
    }

    return { valid: true };
  };

  export const validateDocuments = (files: File[] = []) => {
    const allowedTypes = ["application/pdf"];
    const maxSizeInBytes = 5 * 1024 * 1024;

    if (files.length > 5) {
      return { valid: false, message: "Maximum 5 documents allowed" };
    }

    const invalidType = files.find((file: any) => !allowedTypes.includes(file.type || file.mimetype));
    if (invalidType) {
      return { valid: false, message: "Only PDF documents are allowed" };
    }

    const tooLarge = files.find((file) => file.size > maxSizeInBytes);
    if (tooLarge) {
      return { valid: false, message: "Each document must be less than 5MB" };
    }

    return { valid: true };
  };

  export const customerFormFields = [
    {
      name: "salutation",
      label: "Title",
      type: "select",
      placeholder: "Select Salutation",
    },
    {
      name: "firstName",
      label: "First Name",
      placeholder: "Enter first name",
      type: "textBox",
      required: true,
    },
    {
      name: "lastName",
      label: "Last Name",
      placeholder: "Enter last name",
      type: "textBox",
      required: false,
    },
    {
      name: "email",
      label: "Email",
      placeholder: "Enter email",
      type: "textBox",
      required: true,
    },
    {
      name: "phoneNumber",
      label: "Mobile Number",
      placeholder: "Enter phone number",
      type: "textBox",
      required: true,
    },
    {
      name: "position",
      label: "Position",
      type: "textBox",
      placeholder: "Enter Position",
    },
    {
      name: "companyId",
      label: "Company",
      type: "select",
      placeholder: "Select Company",
      required: true,
    },
    {
      name: "children",
      label: "Children",
      type: "textBox",
      placeholder: "Enter Children Name",
    },
    {
      name: "birthday",
      label: "Birthday",
      type: "date",
      placeholder: "Enter Birthday",
    },
    {
      name: "holidays",
      label: "Holiday",
      type: "textBox",
      placeholder: "Enter Holiday",
    },
    {
      name: "industry",
      label: "Industry",
      type: "textBox",
      placeholder: "Enter Industry",
    },
    {
      name: "hobbies",
      label: "Hobbies",
      type: "textBox",
      placeholder: "Enter Hobbies",
    },
    {
      name: "pets",
      label: "Pets",
      type: "textBox",
      placeholder: "Enter Pets",
    },
    {
      name: "interests",
      label: "Interests",
      type: "textBox",
      placeholder: "Enter Interests",
    },
    {
      name: "age",
      label: "Age",
      type: "number",
      placeholder: "Enter Age",
    },
    {
      name: "additionalNotes",
      label: "Additional Notes",
      type: "textArea",
      placeholder: "Enter Additional Notes",
    },
  ]; 

  export const getRandomColor = () => {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }; 

  export const venueTabDetailsInEnquiryCol: eventCol[] = [
    {
      id: "field",
      label: "Field",
    },
    { id: "value", label: "value" },
  ];
  
  export const enquiryTimeOptions = [
    { label: "This Week", value: "week" },
    { label: "This Month", value: "month" },
    { label: "This Year", value: "year" },
  ];

  export const PROFIT_FILTER_MAP: Record<
  "week" | "month" | "year",
  "thisWeek" | "thisMonth" | "thisYear"
> = {
  week: "thisWeek",
  month: "thisMonth",
  year: "thisYear",
};
  
  export const getDateRangeByFilter = (filter: "year" | "month" | "week") => {
    const now = new Date();
  
    let start: Date;
    let end: Date;
  
    switch (filter) {
      case "year": {
        start = new Date(now.getFullYear(), 0, 1); // Jan 1
        end = new Date(now.getFullYear(), 11, 31, 23, 59, 59); // Dec 31
        break;
      }
  
      case "month": {
        start = new Date(now.getFullYear(), now.getMonth(), 1); // 1st of month
        end = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59); // last day
        break;
      }
  
      case "week": {
        const day = now.getDay(); // 0 (Sun) - 6 (Sat)
        const diffToMonday = day === 0 ? -6 : 1 - day;
  
        start = new Date(now);
        start.setDate(now.getDate() + diffToMonday);
        start.setHours(0, 0, 0, 0);
  
        end = new Date(start);
        end.setDate(start.getDate() + 6);
        end.setHours(23, 59, 59, 999);
        break;
      }
  
      default:
        start = new Date();
        end = new Date();
    }
  
    return {
      start: start.toISOString(),
      end: end.toISOString(),
    };
  };

  export  const eventTypeOptions = [
      "Conference",
      "Wedding",
      "Party",
      "Charity Events",
      "Christmas Party",
      "Summer Party",
      "Award Dinner",
      "Gala Dinner",
      "Conferences",
      "Employee Engagement",
      "Fashion Shows",
      "Product Launch",
      "Incentive Travel",
      "Meeting",
      "Team Building",
      "Ticketed Event"
    ];